(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRotator(el) {
      if (el._rghInit) return;
      el._rghInit = true;

      var sentences;
      try {
        sentences = JSON.parse(el.dataset.sentences || '[]');
      } catch (e) {
        sentences = [];
      }
      sentences = sentences.map(function (s) {
        return s.trim();
      }).filter(Boolean);

      if (sentences.length < 2) return;

      var i = 0;
      setInterval(function () {
        el.classList.add('is-fading');
        setTimeout(function () {
          i = (i + 1) % sentences.length;
          el.textContent = sentences[i];
          el.classList.remove('is-fading');
        }, 200);
      }, 3500);
    }

    function initAll() {
      document.querySelectorAll('[data-rgh-announce-rotator]').forEach(initRotator);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('.rgh-cart-qty__btn');
    if (!btn) return;
    const qty = btn.closest('.rgh-cart-qty');
    const input = qty && qty.querySelector('.rgh-cart-qty__input');
    if (!input) return;
    const current = parseInt(input.value, 10) || 0;
    input.value = btn.name === 'minus' ? Math.max(0, current - 1) : current + 1;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPriceSlider(wrap) {
      var minInput = wrap.querySelector('[data-rgh-price-min]');
      var maxInput = wrap.querySelector('[data-rgh-price-max]');
      var minRange = wrap.querySelector('[data-rgh-price-slider-min-input]');
      var maxRange = wrap.querySelector('[data-rgh-price-slider-max-input]');
      var rangeFill = wrap.querySelector('[data-rgh-price-slider-range]');
      var minLabel = wrap.querySelector('[data-rgh-price-slider-min-label]');
      var maxLabel = wrap.querySelector('[data-rgh-price-slider-max-label]');
      if (!minInput || !maxInput || !minRange || !maxRange) return;

      var rangeMin = parseInt(wrap.dataset.rangeMin, 10) || 0;
      var rangeMax = parseInt(wrap.dataset.rangeMax, 10) || 0;
      var span = rangeMax - rangeMin || 1;
      // Handles may touch (min == max) but never cross past each other.
      var minGap = 0;

      function formatMoney(cents) {
        var amount = cents / 100;
        var rounded = Math.round(amount * 100) / 100;
        var hasFraction = rounded % 1 !== 0;
        return (hasFraction ? rounded.toFixed(2).replace('.', ',') : rounded) + ' lei';
      }

      function update(dispatch) {
        var minVal = parseInt(minRange.value, 10);
        var maxVal = parseInt(maxRange.value, 10);

        if (minVal > maxVal - minGap) {
          minVal = maxVal - minGap;
          minRange.value = minVal;
        }

        var minPct = ((minVal - rangeMin) / span) * 100;
        var maxPct = ((maxVal - rangeMin) / span) * 100;
        if (rangeFill) {
          rangeFill.style.left = minPct + '%';
          rangeFill.style.right = 100 - maxPct + '%';
        }
        if (minLabel) minLabel.textContent = formatMoney(minVal);
        if (maxLabel) maxLabel.textContent = formatMoney(maxVal);

        minInput.value = minVal / 100;
        maxInput.value = maxVal / 100;

        if (dispatch) {
          minInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }

      minRange.addEventListener('input', function () {
        update(true);
      });

      maxRange.addEventListener('input', function () {
        if (parseInt(maxRange.value, 10) < parseInt(minRange.value, 10) + minGap) {
          maxRange.value = parseInt(minRange.value, 10) + minGap;
        }
        update(true);
      });

      update(false);
    }

    document.querySelectorAll('[data-rgh-price-slider]').forEach(initPriceSlider);

    function initFiltersAccordion(panel) {
      var isMobile = function () {
        return window.matchMedia('(max-width: 989px)').matches;
      };

      if (isMobile()) panel.open = false;

      var countEl = document.getElementById('ProductCount');
      var pendingCollapse = false;
      var fallbackTimer = null;

      var collapseNow = function () {
        pendingCollapse = false;
        if (fallbackTimer) window.clearTimeout(fallbackTimer);
        fallbackTimer = null;
        panel.open = false;
      };

      if (countEl && window.MutationObserver) {
        new MutationObserver(function () {
          if (pendingCollapse) collapseNow();
        }).observe(countEl, { childList: true, subtree: true, characterData: true });
      }

      // Excludes .rgh-price-slider__input: a drag-release "change" fires
      // mid-adjustment too, so auto-collapsing on it (unlike a discrete
      // checkbox pick) would hide the slider right after the user's first
      // touch, making it look unresponsive to further dragging.
      panel.querySelectorAll('.rgh-filter-list input').forEach(function (input) {
        input.addEventListener('change', function () {
          if (!isMobile()) return;

          // Filters apply through Dawn's debounced facets-form submit (~800ms).
          // Wait for the product count to actually refresh before collapsing,
          // with a fallback in case that update never arrives.
          pendingCollapse = true;
          if (fallbackTimer) window.clearTimeout(fallbackTimer);
          fallbackTimer = window.setTimeout(collapseNow, 2200);
        });
      });
    }

    document.querySelectorAll('[data-rgh-filters]').forEach(initFiltersAccordion);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rgh-upsell"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Liquid has no random/shuffle filter, so the section above renders a
    // larger pool of eligible products (up to 2 per type) server-side, and
    // this shuffles + trims it down to the configured count - different
    // products, not just a different order, each time. Exposed as
    // window.rghShuffleUpsell (not just run once on load) so cart.js can
    // re-run it after swapping in a freshly-rendered pool on add/remove/
    // quantity change, when the cart's contents (and so the pool) change
    // without a full page reload.
    function shuffleAndTrim(section) {
      var maxVisible = parseInt(section.dataset.maxVisible, 10);
      if (!maxVisible) return;

      var track = section.querySelector('.rgh-product-grid__items');
      if (!track) return;

      var slides = Array.prototype.slice.call(track.querySelectorAll('.rgh-product-grid__slide'));
      if (slides.length <= 1) return;

      for (var i = slides.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = slides[i];
        slides[i] = slides[j];
        slides[j] = temp;
      }

      slides.slice(maxVisible).forEach(function (slide) {
        slide.remove();
      });
      slides.slice(0, maxVisible).forEach(function (slide) {
        track.appendChild(slide);
      });
    }

    function shuffleAllUpsells() {
      document.querySelectorAll('.rgh-upsell[data-max-visible]').forEach(shuffleAndTrim);
    }

    window.rghShuffleUpsell = shuffleAllUpsells;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', shuffleAllUpsells);
    } else {
      shuffleAllUpsells();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
